import type { InterviewKind } from '@Domain/Enums/Interviews/InterviewKind';

class FetchLiveTranscriptionAvailability {
	constructor(
		public readonly facilityId: number,
		public readonly interviewKind: InterviewKind,
	) {
		Object.freeze(this);
	}
}

export default FetchLiveTranscriptionAvailability;
